
import Component from "./index.vue"
export default {
    id: "custom-id-change", // (required) uuid
    icon: require("./icon.svg"), // (required) url to tool icon
    title: "Update Custom ID", // (required) Title shown on content tools view
    description: "Change Content's custom ID property from selected library", // (required) Operation description
    available: true, // (optional) set to true if tool is available to use in the platform
    Component // (required) VueComponent to show when operation is selected
}